export default __webpack_public_path__ + "static/media/dubai-harbour.cb1ef615.webp";